// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { NonSkuGemstoneFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { NonSkuGemstoneBoundsFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuGemstoneBounds.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../../graphql/api/cms/pageProductListing.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const GemstoneSearchDocument = gql`
    query gemstoneSearch($filters: NonSkuGemstoneFilters!, $sort: NonSkuGemstoneSortInput!, $currency: CurrencyInput!, $region: RegionCode!, $locale: Locale!, $contentPath: String!) {
  nonSkuGemStones(
    region: $region
    currency: $currency
    filters: $filters
    sort: $sort
  ) {
    ...nonSkuGemstone
  }
  nonSkuGemStonesBounds {
    ...nonSkuGemstoneBounds
  }
  pageProductListing(path: $contentPath, locale: $locale) {
    ...productPageListing
  }
}
    ${NonSkuGemstoneFragmentDoc}
${NonSkuGemstoneBoundsFragmentDoc}
${ProductPageListingFragmentDoc}`;

export function useGemstoneSearchQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.GemstoneSearchQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.GemstoneSearchQuery, SchemaTypes.GemstoneSearchQueryVariables | undefined>({ query: GemstoneSearchDocument, variables: undefined, ...options });
};